var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mian-container",attrs:{"id":"rootConainer"}},[_c('main-header'),_c('div',{staticClass:"main-inner"},[(_vm.$route.meta.keepAlive)?[_c('keep-alive',[_c('router-view')],1)]:[_c('router-view')]],2),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }